import { AppRouter } from './Routes';
import './App.css';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import StoreProvider from './hooks/useStore';
import AuthProvider from './hooks/useAuth';
import intl from 'react-intl-universal';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Switch, AppBar, Toolbar, Box, Typography } from '@mui/material';
import { useState } from 'react';

const currentLocale = "en-US";
const locales = {
  'en-US': require('./locales/en_US.json'),
  'es-US': require('./locales/es_US.json')
};

intl.init({
  currentLocale,
  locales,
});


const App = () => {
  const [toggleDarkMode, setToggleDarkMode] = useState(false);

  // Theme
  const toggleDarkTheme = () => {
    setToggleDarkMode(!toggleDarkMode);
  };
  
  const theme = createTheme({
    palette: {
      mode: toggleDarkMode ? 'dark' : 'light',
      primary: {
        main: toggleDarkMode ? '#013D71' : '#013D71',
      },
      secondary: {
        main: toggleDarkMode ? '#131052' : '#FFFFFF',
      }
    },
  });
  
 
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <StoreProvider>
          <AuthProvider>
              <AppRouter style={{ width: '100%' }} />
				<AppBar position="fixed" style={{ top: 'auto', bottom: 0, backgroundColor: 'transparent', boxShadow: 'none' }}>
				  <Toolbar style={{ minHeight: '10px', backgroundColor: 'transparent' }}> {/* Adjust the minHeight value here */}
				    <Box style={{ flexGrow: 1 }} />
				    <Typography variant="body2" style={{ color: toggleDarkMode ? '#FFFFFF' : '#000000', marginRight: '8px' }}>
				      {toggleDarkMode ? 'Dark' : 'Light'}
				    </Typography>
				    <Switch size="small" checked={toggleDarkMode} onChange={toggleDarkTheme} />
				  </Toolbar>
				</AppBar>
          </AuthProvider>
        </StoreProvider>
      </LocalizationProvider>
    </ThemeProvider>
  );
};

export default App;